import { useProfileAnalysisFilters } from '../../../hooks/useProfileAnalysisFilters'
import { useRiskProfileQueryParams } from '../../../hooks/useRiskProfileQueryParams'
import { GroupStatsSection } from './GroupStatsSection'
import { GroupMetricControl } from './GroupMetricControl'
import { GroupChartsSection } from './GroupChartsSection'
import { GroupResultsSection } from './GroupResultsSection'
import { RiskByAreaWidget } from '../widgets/RiskByAreaWidget'

export function GroupAnalysis() {
  const {
    metricOption,
    areaGroup,
    areas,
    selectedHazardGroups,
    selectedElementGroups,
    selectedWorkspace,
    selectedAreaTypesLabel,
    setMetricOption,
    damageStates,
  } = useProfileAnalysisFilters()

  const queryParams = useRiskProfileQueryParams({
    metric: metricOption.metric,
    selectedWorkspace,
    areaGroup,
    areas,
    selectedHazardGroups,
    selectedElementGroups,
    damageStates,
  })

  return (
    <div className="space-y-5">
      <GroupStatsSection queryParams={queryParams} metricOption={metricOption} />
      <GroupMetricControl metricOption={metricOption} onMetricChange={setMetricOption} />
      <GroupChartsSection queryParams={queryParams} metricOption={metricOption} />
      {areaGroup !== '' && (
        <RiskByAreaWidget
          queryParams={queryParams}
          metricOption={metricOption}
          areas={areas}
          selectedAreaTypesLabel={selectedAreaTypesLabel}
        />
      )}
      <GroupResultsSection queryParams={queryParams} />
    </div>
  )
}
